module.exports = __webpack_public_path__ + "img/borderRingWhite.0e9ce566.svg";